export const spinner = state => state.spinner;

export const notification = state => state.notification;

export const modal = state => state.modal;

export const connected = state => state.connected;

export const getScrollBlock = state => state.scrollBlock.block;

export const getPositionScrollY = state => state.scrollBlock.positionScrollY;
